(function () {
  if (!window.__tk9DogDadBridgeLoader) {
    var tk9DogDadStart = Date.parse("2026-06-18T05:00:00Z");
    var tk9DogDadEnd = Date.parse("2026-06-23T04:59:59Z");
    var tk9DogDadNow = Date.now();
    if (
      isFinite(tk9DogDadStart) &&
      isFinite(tk9DogDadEnd) &&
      tk9DogDadNow >= tk9DogDadStart &&
      tk9DogDadNow <= tk9DogDadEnd &&
      !document.querySelector(".tk9-dogdad-header,.tk9-fd-hero")
    ) {
      window.__tk9DogDadBridgeLoader = true;
      var tk9DogDadScript = document.createElement("script");
      tk9DogDadScript.src = "https://teamk9.com/cdn/shop/t/70/assets/tk9-slide-cart-stale-guard.js?v=20260618181000";
      tk9DogDadScript.defer = true;
      (document.head || document.documentElement).appendChild(tk9DogDadScript);
    }
  }

  var isProductPage =
    window.location.pathname.indexOf("/products/") === 0 ||
    Boolean(document.querySelector('[data-template="product"], main[data-template="product"]'));

  if (!isProductPage || window.__tk9SizeGuideAnchor) return;
  window.__tk9SizeGuideAnchor = true;

  var hiddenClass = "tk9-size-guide-hidden";
  var scheduled = false;

  function ensureStyles() {
    if (document.getElementById("tk9-size-guide-anchor-style")) return;
    var style = document.createElement("style");
    style.id = "tk9-size-guide-anchor-style";
    style.textContent = "." + hiddenClass + "{display:none!important}";
    document.head.appendChild(style);
  }

  function hasSizeGuideText(node) {
    return /size\s*guide/i.test((node && node.textContent) || "");
  }

  function findSizeOption() {
    var options = document.querySelectorAll("variant-swatch-king [option-name], .swatches [option-name]");

    for (var index = 0; index < options.length; index += 1) {
      var option = options[index];
      var name = option.getAttribute("option-name") || "";
      if (/size/i.test(name)) return option;
    }

    var fallback = document.querySelector("#swatch-option2");
    if (fallback && /size/i.test(fallback.textContent || "")) return fallback;

    return null;
  }

  function ensureSlot(sizeOption) {
    var labelContainer =
      sizeOption.querySelector(".swatch-label-container") || sizeOption.querySelector("fieldset") || sizeOption;
    var slot = labelContainer.querySelector(".swatch-size-chart");

    if (!slot) {
      slot = document.createElement("span");
      slot.className = "swatch-size-chart";
      labelContainer.appendChild(slot);
    }

    return slot;
  }

  function getCharts() {
    var seen = [];
    var charts = [];

    function add(node) {
      if (!node || seen.indexOf(node) !== -1 || !hasSizeGuideText(node)) return;
      if (node.closest("template")) return;
      seen.push(node);
      charts.push(node);
    }

    document.querySelectorAll(".best-fit-size-chart").forEach(add);
    document.querySelectorAll(".scr-open-size-chart").forEach(function (button) {
      add(button.closest(".best-fit-size-chart") || button.parentElement || button);
    });

    return charts;
  }

  function anchorSizeGuide() {
    var sizeOption = findSizeOption();
    var charts = getCharts();

    if (!sizeOption || !charts.length) return false;

    var slot = ensureSlot(sizeOption);
    var primary =
      charts.find(function (chart) {
        return slot.contains(chart);
      }) ||
      charts.find(function (chart) {
        return sizeOption.contains(chart);
      }) ||
      charts[0];

    if (!primary) return false;

    ensureStyles();

    if (!slot.contains(primary)) {
      slot.appendChild(primary);
    }

    primary.classList.remove(hiddenClass);
    primary.removeAttribute("aria-hidden");
    primary.setAttribute("data-tk9-size-guide-anchor", "size-row");

    charts.forEach(function (chart) {
      if (chart === primary) return;
      chart.classList.add(hiddenClass);
      chart.setAttribute("aria-hidden", "true");
    });

    return true;
  }

  function scheduleAnchor() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      anchorSizeGuide();
    });
  }

  anchorSizeGuide();
  document.addEventListener("DOMContentLoaded", scheduleAnchor);
  window.addEventListener("load", scheduleAnchor);
  document.addEventListener("shopify:section:load", scheduleAnchor);

  if (window.MutationObserver) {
    new MutationObserver(scheduleAnchor).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  var attempts = 0;
  var retry = window.setInterval(function () {
    attempts += 1;
    anchorSizeGuide();
    if (attempts >= 80) window.clearInterval(retry);
  }, 500);
})();
